<template>

	<div class="page container">
		<v2-back-btn />

		<div class="page__info" v-if="getNameString">
			<div class="page__info--title">
				{{ getNameString }}
			</div>
		</div>

		<div>
			<list-view
				v-if="getStudent"
				:list="getList"
			/>
		</div>
	</div>
</template>

<script>
	import ListView      from '@/components/ui/views/listView/ListView';
	import routeParams   from '@/mixins/routeParams';
	import api           from '@/services/api';
	import dayjs         from 'dayjs';
	import relativeTime  from 'dayjs/plugin/relativeTime';
	import V2BackBtn from '@/components/v2/ui/V2BackBtn';

	dayjs.extend(relativeTime);

	export default {
		metaInfo: {
			title: 'Student overview'
		},

		layout: 'v2default',

		components: {
			V2BackBtn,
			ListView
		},
		mixins: [routeParams],
		data: () => ({
			student: undefined
		}),
		computed: {
			getStudentId () {
				return this.$route.params.studentId;
			},
			getCourseId () {
				return this.$route.params.courseId;
			},
			getBreadcrumbRoute () {
				if (!this.getStudentId ||
						!this.getCourseId) {
					return false;
				}
				return `/teaching/courses/${this.getCourseId}/students/`;
			},
			getStudent () {
				if (!this.student ||
						!this.student.id) {
					return false;
				}
				return this.student;
			},
			getNameString (student) {
				if (!this.getStudent) {
					return false;
				}
				return `${this.getStudent.firstName} ${this.getStudent.lastName}`;
			},
			getList () {
				if (!this.getStudent) {
					return false;
				}
				return [
					{
						text: `Is enrolled in ${this.student.numCourses} of my courses`
					},
					{
						text: `Preferred bidding system: ${this.student.biddingSystem}`
					},
					{
						text: `Experience level: ${this.student.experienceLevel}`
					}
				];
			},
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: this.getCoursesRoute,
						text: 'Courses'
					},
					{
						path: this.getCourseRoute,
						text: 'Course'
					},
					{
						path: `${this.getCourseRoute}/students`,
						text: 'Students'
					},
					{
						path: `${this.getCourseRoute}/students/${this.getStudentId}`,
						text: this.getNameString
					}
				];
			}
		},
		created: function () {
			this.setStudent();
		},
		methods: {
			async setStudent () {
				const student = await api.teaching.getStudentById({
					studentId: this.getStudentId
				});
				if (!student) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.student = student;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};
</script>
